// TODO: move this to `fe-config`
import uniq from 'lodash/uniq';

import type { Locale } from '@change-corgi/config/locales';

type HomepageL10n = { lang: Locale; country_code?: string; hrefLang: string };
type HomepageL10nMap = Partial<Record<string, HomepageL10n>>;
export const HOMEPAGE_L10N_MAP: HomepageL10nMap = {
	es: { lang: 'es-ES', country_code: 'ES', hrefLang: 'es' },
	fr: { lang: 'fr-FR', country_code: 'FR', hrefLang: 'fr' },
	'en-au': { lang: 'en-AU', country_code: 'AU', hrefLang: 'en-AU' },
	'en-ca': { lang: 'en-CA', country_code: 'CA', hrefLang: 'en-CA' },
	'en-gb': { lang: 'en-GB', country_code: 'GB', hrefLang: 'en-GB' },
	'en-in': { lang: 'en-IN', country_code: 'IN', hrefLang: 'en-IN' },
	'en-us': { lang: 'en-US', country_code: 'US', hrefLang: 'en-US' },
	'es-ar': { lang: 'es-AR', country_code: 'AR', hrefLang: 'es-AR' },
	ru: { lang: 'ru-RU', country_code: 'RU', hrefLang: 'ru' },
	'pt-br': { lang: 'pt-BR', country_code: 'BR', hrefLang: 'pt-BR' },
	it: { lang: 'it-IT', country_code: 'IT', hrefLang: 'it' },
	tr: { lang: 'tr-TR', country_code: 'TR', hrefLang: 'tr' },
	id: { lang: 'id-ID', country_code: 'ID', hrefLang: 'id' },
	ja: { lang: 'ja-JP', country_code: 'JP', hrefLang: 'ja' },
	'es-la': { lang: 'es-419', country_code: undefined, hrefLang: 'es-419' },
	th: { lang: 'th-TH', country_code: 'TH', hrefLang: 'th' },
	de: { lang: 'de-DE', country_code: 'DE', hrefLang: 'de' },
	hi: { lang: 'hi-IN', country_code: 'IN', hrefLang: 'hi' },
} as const;
export const HOMEPAGE_LOCALES = Object.keys(HOMEPAGE_L10N_MAP);
// FIXME in theory we could use the "lang" property for hrefLang, if we're ok with using the full locale code
export const HOMEPAGE_HREF_LANGS = Object.entries(HOMEPAGE_L10N_MAP)
	.filter((e): e is [string, HomepageL10n] => !!e[1])
	.map(([slug, { hrefLang, lang }]) => ({ hrefLang, lang, slug }));

export type SapL10n = { lang: Locale; country_code?: string; sap: string };
export type SapL10nMap = Partial<Record<string, SapL10n>>;
export const SAP_L10N_MAP: SapL10nMap = {
	es: { lang: 'es-ES', country_code: 'ES', sap: 'iniciar-una-petición' },
	fr: { lang: 'fr-FR', country_code: 'FR', sap: 'lancer-une-pétition' },
	'en-au': { lang: 'en-AU', country_code: 'AU', sap: 'start-a-petition' },
	'en-ca': { lang: 'en-CA', country_code: 'CA', sap: 'start-a-petition' },
	'en-gb': { lang: 'en-GB', country_code: 'GB', sap: 'start-a-petition' },
	'en-in': { lang: 'en-IN', country_code: 'IN', sap: 'start-a-petition' },
	'en-us': { lang: 'en-US', country_code: 'US', sap: 'start-a-petition' },
	'es-ar': { lang: 'es-AR', country_code: 'AR', sap: 'iniciar-una-petición' },
	ru: { lang: 'ru-RU', country_code: 'RU', sap: 'создать-петицию' },
	'pt-br': { lang: 'pt-BR', country_code: 'BR', sap: 'inicie-uma-petição' },
	it: { lang: 'it-IT', country_code: 'IT', sap: 'lancia-una-petizione' },
	tr: { lang: 'tr-TR', country_code: 'TR', sap: 'kampanyanı-başlat' },
	id: { lang: 'id-ID', country_code: 'ID', sap: 'mulai-sebuah-petisi' },
	ja: { lang: 'ja-JP', country_code: 'JP', sap: 'スタート' },
	'es-la': { lang: 'es-419', sap: 'inizia-una-petizione' },
	th: { lang: 'th-TH', country_code: 'TH', sap: 'สร้างแคมเปญรณรงค์' },
	de: { lang: 'de-DE', country_code: 'DE', sap: 'eine-petition-starten' },
	// beta locales
	ph: { lang: 'tl-PH', country_code: 'PH', sap: 'magsimula-ng-petisyon' },
	ko: { lang: 'ko-KR', country_code: 'KR', sap: '캠페인-시작하기' },
} as const;
export const SAP_LOCALES = Object.keys(SAP_L10N_MAP);
export const SAP_SLUGS = uniq(Object.values(SAP_L10N_MAP as Record<string, SapL10n>).map(({ sap }) => sap));
export const SAP_SLUGS_ENCODED = SAP_SLUGS.map((slug) => encodeURIComponent(slug).toLowerCase());
